<template>
  <b-modal
    ref="bModal"
    no-fade
    modal-class="laboratory-tracking-instrument-modal"
    style="z-index:0"
    hide-backdrop
  >
    <template slot="modal-title">
      <span>{{ title }}</span>
    </template>

    <div class="px-3">
      <b-row>
        <b-col>
          <small>{{ $tc('laboratory.tracking.selectElement') }}</small>
          <div class="selector-scroll">
            <b-form-group>
              <b-form-radio-group
                id="radio-group-2"
                v-model="instrumentSelected"
                v-testing="'instrument'"
                buttons
                stacked
                name="radio-sub-component"
              >
                <b-form-radio
                  v-for="device of devices"
                  :key="device.id"
                  :value="device"
                >
                  <div class="d-flex align-items-center">
                    <div class="d-flex justify-content-center">
                      <i
                        v-if="instrumentSelected && instrumentSelected.id === device.id"
                        class="fal fa-check-circle selected"
                        aria-hidden="true"
                      />
                      <i
                        v-else
                        class="fal fa-circle no-selected"
                        aria-hidden="true"
                      />
                    </div>
                    <span>{{ device.device }}</span>
                  </div>
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col>
          <div class="d-flex justify-content-end align-items-center">
            <div class="mr-3">
              <h5 class="card-info label-dark">
                {{ $tc('laboratory.content.fixElement') }}
              </h5>
            </div>
            <div class="switch-btn p-0 d-flex align-items-center justify-content-center">
              <input
                id="fix-instrument"
                v-model="instrumentFixed"
                v-testing="'fix-instrument-switch'"
                type="checkbox"
                class="offscreen"
                aria-hidden="true"
              >
              <label
                for="fix-instrument"
                class="switch mb-0"
              />
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <div class="d-flex justify-content-end align-items-center">
            <div class="mr-3">
              <h5 class="card-info label-dark">
                {{ $tc('laboratory.content.overwriteExisting') }}
              </h5>
            </div>
            <div class="switch-btn p-0 align-items-center justify-content-center">
              <input
                id="overwrite-instrument"
                v-model="instrumentOverwritten"
                v-testing="'overwrite-instrument-switch'"
                type="checkbox"
                class="offscreen"
                aria-hidden="true"
              >
              <label
                for="overwrite-instrument"
                class="switch mb-0"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-12 text-right">
          <b-button
            v-testing="'apply'"
            class="btn--primary"
            :disabled="!modelValidated"
            @click="applyDevice(hide)"
          >
            <i
              class="fal fa-check"
              aria-hidden="true"
            />
            {{ $tc('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import instrumentsModalMixin from '@/modules/laboratoryModule/mixins/instrumentsModalMixin'

export default {
    name: 'LaboratoryTrackingInstrumentModalForm',
    mixins: [
        instrumentsModalMixin
    ],
    methods: {
        show() {
            this.resetInstrumentsModalData()
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .laboratory-tracking-instrument-modal .card-info {
        margin-bottom: 0;
    }
    .laboratory-tracking-instrument-modal .selector-scroll {
        background: vt-color(scroll-bg, .9);
        max-height: 350px;
        overflow-y: auto;
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical {
        width: 100%;
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical .btn {
        margin-bottom: 5px;
        border-radius: 0.25rem !important;
        text-align: left;
        padding: 10px;
        background: transparent;
        color: vt-color(header-text);
        border-color: transparent !important;
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical .btn:last-child,
    .laboratory-tracking-instrument-modal .form-group {
        margin-bottom: 0;
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical .btn.active {
        background: vt-color(green-radiant, .9);
        color: vt-color(header-text);
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical .btn.active.focus {
         box-shadow: none;
     }
    .laboratory-tracking-instrument-modal .btn-secondary:not(:disabled):not(.disabled):active {
        background: transparent;
        color: vt-color(header-text);
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical i {
        font-size: 20px;
        margin-right: 15px;
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical i.no-selected {
        color: vt-color(base-text);
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical i.selected {
        color: vt-color(green-radiant);
    }
    .laboratory-tracking-instrument-modal .btn-group-vertical span {
        font-size: font-size(normal);
    }
    .laboratory-tracking-instrument-modal .modalIncidentForm .modal-content {
        box-shadow: none;
    }
    .laboratory-tracking-instrument-modal .modal-dialog {
        width: 45% !important;
        margin: 0;
        position: absolute;
        right: 0;
    }
    .laboratory-tracking-instrument-modal .modal-body {
        padding: 0.6rem 1.1rem 0 1.1rem !important;
    }
    .laboratory-tracking-instrument-modal .modal-content {
        top: 50px;
        height: calc(100vh - 78px);
        border-radius: 0;
        box-shadow: -3px 0px 10px 2px #8f8f8f !important;
    }
    .laboratory-tracking-instrument-modal .modal-footer {
        border-top: 0;
    }
</style>

<style lang="scss" scoped>

    .laboratory-tracking-instrument-modal h4 {
        font-weight: normal;
    }

    .offscreen {
        position: absolute;
        left: -9999px;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 20px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
    }

    .switch::after {
        content: '';
        position: absolute;
        width: 18px;
        height: 18px;
        border-radius: 18px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }

    input[type='checkbox']:checked + .switch::after {
        transform: translateX(20px);
    }

    input[type='checkbox']:checked + .switch {
        background-color: vt-color(primary);
    }

</style>
